import React from 'react';
import { FullBackground } from '../../../components/FullBackground';
import { getImageSrc } from '../../../util';
import ProductFAQs from './ProductFAQs';

type Props = {
  className?: string;
};

const ProductOrderPay: React.FC<Props> = ({ className }) => {
  return (
    <>
      <FullBackground color={'bg-gray-100'}>
        <div
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          className={`${className}`}
          id={'order-pay'}
        >
          <div className="py-16 lg:mb-40 xl:mb-32">
            <div className="relative max-w-xl max-w-7xl justify-center">
              <div className="relative mt-8 lg:mt-12 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center justify-center lg:space-x-10">
                <div className="relative">
                  <div className="max-w-3xl  text-left">
                    <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">
                      Mobile Order & Payment
                    </h2>
                    <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      A digital tab for guests to order and pay from.
                    </p>

                    <div className="text-xl text-gray-700 sm:text-xl mt-4 xl:mt-6">
                      <p>
                        Capture orders instantly through your TableTab menu and
                        forget about handling payment. We take care of it all.
                      </p>
                    </div>
                  </div>
                  <dl className="mt-10 space-y-10">
                    <div className="flex">
                      <div className="">
                        <dt className="text-lg leading-6 font-medium text-gray-900 ">
                          One digital tab for limitless orders
                        </dt>
                        <dd className="mt-2 text-base text-gray-700 ">
                          TableTab's order and payment process allows guests to
                          order multiple times throughout their dining
                          experience under a single tab.
                        </dd>
                      </div>
                    </div>
                    <div className="flex">
                      <div className="">
                        <dt className="text-lg leading-6 font-medium text-gray-900 ">
                          Automatic payment to simplify operations
                        </dt>
                        <dd className="mt-2 text-base text-gray-700 ">
                          We preauthorize guests' payment method when they open
                          a tab, update it with each order, and charge the card
                          on file when guest is done.
                        </dd>
                      </div>
                    </div>
                    <div className="flex">
                      <div className="">
                        <dt className="text-lg leading-6 font-medium text-gray-900 ">
                          Consolidated tickets for easy staff management
                        </dt>
                        <dd className="mt-2 text-base text-gray-700 ">
                          All orders from a table are consolidated under one
                          ticket that can be managed by staff. Additional orders
                          update tickets automatically.
                        </dd>
                      </div>
                    </div>
                  </dl>
                  <ProductFAQs className={'mt-4 py-16'} />
                </div>

                <div className="mt-10  lg:mt-0 relative " aria-hidden="true">
                  <div className="relative py-3 w-2/3 md:w-1/2 lg:w-2/3 2xl:w-4/5 mx-auto justify-center">
                    <div
                      className={'relative  w-full mx-auto md:w-full 2xl:w-3/4'}
                    >
                      <picture>
                        <source
                          srcSet={getImageSrc('DigitalTab4.webp')}
                          type="image/webp"
                        />
                        <source
                          srcSet={getImageSrc('DigitalTab4.png')}
                          type="image/png"
                        />
                        <img
                          src={getImageSrc('DigitalTab4.webp')}
                          alt={'payments'}
                        />{' '}
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default ProductOrderPay;
